import { Box, MenuItem, Select } from '@mui/material';

export const UserServersPanel = ({ apiKeys, apiType, serverName, setApiType, setServerName }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, marginBottom: 2 }}>
      <Select value={apiType} onChange={(e) => setApiType(e.target.value)}>
        {apiKeys.apiTypes?.length > 0 ? (
          apiKeys.apiTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>Нет доступных API</MenuItem>
        )}
      </Select>
      <Select value={serverName} onChange={(e) => setServerName(e.target.value)}>
        {apiKeys.serverNames[apiType]?.length > 0 ? (
          apiKeys.serverNames[apiType].map((server) => (
            <MenuItem key={server} value={server}>
              {server}
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>Нет доступных серверов</MenuItem>
        )}
      </Select>
    </Box>
  );
};
